import { Divider, Stack } from '@mui/material';
import type { InventoryResource, Snapshot, AzureDisk } from '@repo/api-gw-sdk';

import { useViewParameters } from '@/contexts/navigation';
import { useWorkspace } from '@/contexts/useWorkspace';
import type { SidePanelStore } from '@/contexts/workspaceContext';

import { SnapshotDetails } from './snapshotDetails';
import type { RestoreActionType, VMSnapshotRowProps } from './vmSnapshotRow';

import { Panels } from '../../panels';

export const AzureVMSnapshotRow = ({
  snap,
  vault,
  isSelected,
  onSelect,
  resource,
  snapshotSelection,
}: VMSnapshotRowProps) => {
  const { rightPanel } = useWorkspace();
  const { removeParam } = useViewParameters();

  const onClose = () => {
    rightPanel.setIsOpen(false);
    removeParam('id');
  };

  const onBack = () => {
    rightPanel.setComponent({
      panel: Panels.InventoryInstance,
      props: {
        id: resource.id,
        onClose,
        initialTab: 'eon-snapshots',
      },
    });
  };

  return (
    <Stack data-testid='vm-snapshot-row' key={snap.id} className='w-full'>
      <SnapshotDetails
        resource={resource}
        key={snap.id}
        isSelected={isSelected}
        onSelect={onSelect}
        snap={snap}
        vault={vault}
        snapshotSelection={snapshotSelection}
        onRestore={(volumes, actionType) =>
          onAzureRestore(
            volumes.filter(
              (x) => 'settings' in x && 'tier' in x.settings
            ) as AzureDisk[],
            actionType,
            rightPanel,
            snap,
            resource,
            onClose,
            onBack
          )
        }
      />
      <Divider />
    </Stack>
  );
};

const onAzureRestore = (
  vols: AzureDisk[],
  actionType: RestoreActionType,
  panel: SidePanelStore,
  snap: Snapshot,
  entity: InventoryResource,
  onClose: () => void,
  onBack: () => void
) => {
  if (vols.length === 0) {
    return;
  }

  switch (actionType) {
    case 'full-instance':
      panel.setComponent({
        panel: Panels.RestoreAzureVMWizard,
        props: {
          snapshot: snap,
          resource: entity,
          onClose,
          onBack,
        },
      });
      break;
    case 'volume':
      panel.setComponent({
        panel: Panels.RestoreAzureDiskWizard,
        props: {
          snapshot: snap,
          resource: entity,
          disk: vols[0],
          onClose,
          onBack,
        },
      });
  }
};
